import React from 'react';

// Animation de chargement de marque : l'emblème Hippocrate qui pulse pendant les analyses.
export const BrandLoader = ({ label = 'Analyse en cours…', size = 76 }) => (
  <div className="flex flex-col items-center justify-center gap-4 py-6" data-testid="brand-loader">
    <div className="brand-loader-wrap" style={{ width: size, height: size }}>
      <span className="brand-loader-ring" />
      <img src="/logo.png" alt="" className="brand-loader-logo" />
    </div>
    {label && <p className="text-sm text-slate-400 animate-pulse">{label}</p>}
    <style>{`
      .brand-loader-wrap { position: relative; display: grid; place-items: center; }
      .brand-loader-logo {
        width: 70%; height: 70%; object-fit: contain; border-radius: 14px;
        animation: blPulse 1.8s ease-in-out infinite;
        filter: drop-shadow(0 0 12px rgba(56,189,248,0.4));
      }
      .brand-loader-ring {
        position: absolute; inset: 0; border-radius: 9999px;
        border: 2px solid transparent;
        border-top-color: rgba(56,189,248,0.95);
        border-right-color: rgba(129,140,248,0.6);
        animation: blSpin 1s linear infinite;
      }
      @keyframes blSpin { to { transform: rotate(360deg); } }
      @keyframes blPulse { 0%, 100% { transform: scale(0.9); opacity: 0.85; } 50% { transform: scale(1); opacity: 1; } }
    `}</style>
  </div>
);
